import { useEffect, useState } from 'react';

import { fetchEditStatus } from '../requests/user';

export const useProfileEditStatus = ({ userId }) => {
  const [isEditAllowed, setIsEditAllowed] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStatus = async () => {
      // Don't fetch if userId is not available
      if (!userId) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetchEditStatus(userId);
        setIsEditAllowed(response.allowProfileEdit);
      } catch (err) {
        setError('Failed to fetch profile edit status');
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [userId]);

  return { isEditAllowed, loading, error };
};
